import { useGetCustomerApi } from './api/customer/useGetCustomer.api';
import { useIsUserAuthenticated } from './useIsUserAuthenticated.hook';
export var useCustomerData = function () {
    var isAuthenticated = useIsUserAuthenticated().isAuthenticated;
    var _a = useGetCustomerApi(Boolean(isAuthenticated)), customer = _a.data, isLoading = _a.isLoading, error = _a.error;
    return {
        customer: customer,
        isLoading: isLoading,
        error: error,
    };
};
